export const SELECTED_OFFER_SET = 'SELECTED_OFFER_SET';
export const OFFER_SAVE_SUCCESS = 'OFFER_SAVE_SUCCESS';
